import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'environments/environment';

@Injectable()
export class MonitoramentoService {
  appInsights: ApplicationInsights;
  private _ambienteProducao: boolean = environment.PRODUCAO;
  private _chaveAppInsights: string = environment.appInsights.instrumentationKey;

  constructor() {
    if(this._chaveAppInsights == '')
      return;

    if (this._ambienteProducao) {
      this.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: this._chaveAppInsights,
          enableAutoRouteTracking: true // option to log all route changes
        }
      });
      this.appInsights.loadAppInsights();
    }
  }

  logPageView(name?: string, url?: string) { // option to call manually
    this.protegeInstanciaAppInsights()?.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.protegeInstanciaAppInsights()?.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.protegeInstanciaAppInsights()?.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.protegeInstanciaAppInsights()?.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.protegeInstanciaAppInsights()?.trackTrace({ message: message }, properties);
  }

  protegeInstanciaAppInsights(): ApplicationInsights | null{
    if(this._chaveAppInsights == '')
      return null;

    return this.appInsights;
  }

}
